import PageHero from '@/components/feature/PageHero';
import { scaleHero } from '@/mocks/scale';

export default function Hero() {
  return (
    <PageHero
      eyebrow={scaleHero.eyebrow}
      title={scaleHero.title}
      titleHighlight={scaleHero.titleHighlight}
      subtitle={scaleHero.subtitle}
      desc={scaleHero.desc}
      imageUrl="https://readdy.ai/api/search-image?query=Aerial%20abstract%20visualization%20of%20China%20county%20and%20village%20digital%20network%20expanding%20outward%20from%20a%20central%20glowing%20hub%2C%20connected%20nodes%20and%20flowing%20data%20streams%2C%20deep%20navy%20ink%20background%20with%20eco%20green%20and%20gold%20accent%20particles%2C%20national%20strategy%20technology%20aesthetic%2C%20cinematic%20minimal%20composition&width=1800&height=1200&seq=scale-hero-01&orientation=landscape"
      imageAlt="千县万村 全国数字商业网络"
      imageTitle="九畴云铺 千县万村"
    />
  );
}